export class SaasTeamProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "mail",
            "baseName": "mail",
            "type": "string",
            "format": ""
        },
        {
            "name": "visibility",
            "baseName": "visibility",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasTeamProperties.attributeTypeMap;
    }
    constructor() {
    }
}
